import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ciudadanos, API_usuarios } from "../../config/apiConfig";
import Navbar from "../../components/Navbar";
import FormularioCambiarContrasena from "../../components/perfil/FormularioCambiarContrasena";
import ActivarDesactivar from "../../components/perfil/ActivarDesactivar";
import "./css/Perfil.css";
import { useAuth } from "../../context/AuthContext";

const Perfil = () => {
  const { user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");
  const { token } = useAuth();

  useEffect(() => {
    const fetchUsuario = async () => {
      try {


        // 1. Buscar el usuario logueado en /users
        const usersRes = await fetch(`${API_usuarios}`, {
          headers: {
            "x-auth-token": token,
          },
        });
        const usersData = await usersRes.json();

        const usuario = usersData.find(
          (u) => u.email?.toLowerCase() === user?.email?.toLowerCase()
        );

        if (!usuario) {
          setError("No se encontró al usuario en /users.");
          return;
        }

        // 2. Buscar datos extendidos en /ciudadanos con name + lastName
        const ciudadanosRes = await fetch(API_ciudadanos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const ciudadanosData = await ciudadanosRes.json();

        //normalizar los strings para quitar tildes
        const normalize = (str) =>
          str
            ?.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();

        const ciudadano = ciudadanosData.find(
          (c) =>
            normalize(c.name) === normalize(usuario.name) &&
            normalize(c.lastName) === normalize(usuario.lastName)
        );
        if (!ciudadano) {
          setError("No se encontró al usuario en /ciudadanos.");
          return;
        }

        // 3. Combinamos los datos (por ejemplo, para obtener el email)
        setUserData({
          ...ciudadano,
          email: usuario.email,
        });
      } catch (err) {
        console.error("Error al obtener los datos:", err);
        setError("Hubo un error al cargar los datos del perfil.");
      }
    };

    if (user?.email) {
      fetchUsuario();
    }
  }, [user, token]);

  return (
    <>
      <Navbar />

      <main className="main mi-perfil between">
        <article className="datos">
          {error ? (
            <p className="error">{error}</p>
          ) : userData ? (
            <>
              <h1 className="verde mayusculas">
                {userData.name} {userData.lastName}
              </h1>
              <p className="correo">{userData.email}</p>
              <p>{userData.phone}</p>

              <ActivarDesactivar
                status={userData?.estadoUsuario}
                userId={userData?.userId}
              />
            </>
          ) : (
            <p>Cargando...</p>
          )}
        </article>

        <FormularioCambiarContrasena />
      </main>
    </>
  );
};

export default Perfil;
